import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { ToggleLabel as h, ToggleInput as g, ToggleHandle as a, ToggleMask as n } from "./styles.js";
const f = c(({ className: i, ...r }, l) => {
  const { checked: o, defaultChecked: d } = r;
  return /* @__PURE__ */ t(h, { $checked: o || d, className: i, children: [
    /* @__PURE__ */ e(
      g,
      {
        type: "checkbox",
        role: "switch",
        "aria-checked": !!o || !!d,
        ref: l,
        ...r
      }
    ),
    /* @__PURE__ */ e(a, { $highlighted: !0, "aria-hidden": "true", children: "On" }),
    /* @__PURE__ */ e(a, { "aria-hidden": "true", children: "Off" }),
    /* @__PURE__ */ e(n, { "aria-hidden": "true" })
  ] });
});
f.displayName = "Toggle";
export {
  f as Toggle
};
//# sourceMappingURL=Toggle.js.map
